module.exports = __webpack_public_path__ + "static/media/attr_room.67a96fcd.svg";